<template>
  <div>
    <div v-if="!allLoaded">
      <skeleton />
    </div>
    <div v-else class="guide-management">
      <template v-if="!heartbeat">
        <header-banner
            :heartbeat = "heartbeat"
            :family = "family"
        />
        <profile-name
            :name="profile.firstname"
            @completed="handleProcessComplete"
        />
      </template>
      <div v-else class="container-fluid">
        <div class="row">
          <div class="col-lg-3">
            <!--ProfileCard -->
            <profile-card
                :profile="profile"
                :heartbeat="heartbeat"
                :heartbeat-info="theHeartBeatInfo"
                :family = "family"
            />
            <tiles-card
              :profile="profile"
              :heartbeat="heartbeat"
              :heartbeat-info="theHeartBeatInfo"
            />
          </div>
          <div class="col-lg-9" style="margin-top: 25px;">
            <main-section
                :apps="apps"
                :profile="profile"
                :heartbeat="heartbeat"
            />
          </div>
        </div>
      </div>
    </div>
    <vimeo-modal
        :id="videoModalId"
        :video-id="videoId"
        :video-thumb="videoThumb"
    />
    <tutorial-modal
        v-if="profileVideo"
        :id="guideVideo"
        :img="profileVideo.videoThumb"
        :video="{ videoId: profileVideo.videoId }"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Skeleton from "./_skeleton";
import HeaderBanner from "./headerBanner";
import TilesCard from "./_tilesCard";
import ProfileCard from "./_profileCard";
import Communicate from "./communicate";
import ProfileName from "./profileName";
import BodyCommunicate from "./bodyCommunicate";

import ProfileInfo from "@/views/app/manage/platform/profileInfo";
import Socials from "@/views/app/manage/platform/socials";
import Tags from "@/views/app/manage/platform/tags";
import Faqs from "@/views/app/manage/platform/faqs";
import Plans from "@/views/app/manage/platform/plans";
import Sessions from "@/views/app/manage/platform/sessions";
import Publishings from "@/views/app/manage/platform/publishings";
import Tracks from "@/views/app/manage/_shared/jat";

import VimeoModal from "@/components/common/vimeoModal";
import TimeAgo from "vue2-timeago";
import VideoHandling from "@/mixins/VideoHandling";


import MainSection from "./_mainSection";

export default {
  name: "HeartBeat",
  mixins: [VideoHandling],
  components: {
    MainSection,
    Skeleton,
    HeaderBanner,
    TilesCard,
    ProfileCard,
    Communicate,
    BodyCommunicate,
    ProfileName,
    VimeoModal,
    TimeAgo,
  },
  created(){
    this.$watch(
        () => this.$route.params,
        (toParams, previousParams) => {
          //https://router.vuejs.org/guide/essentials/dynamic-matching.html
          this.heartbeatSlug = this.$route.params.heartbeatSlug;
          this.heartBeatVerificationCheckAndDataPull();
        }
    )
  },
  beforeMount() {
    this.heartbeatSlug = this.$route.params.heartbeatSlug;
  },
  mounted() {
    this.getHeartbeatsIfNecessary().then(res => {
      if (this.heartbeat && this.profile) {
        this.heartBeatVerificationCheckAndDataPull();
      }
    });
    if (this.profile && typeof this.profile.email != typeof undefined)
      this.isLoading = false;
    //this.getVideoThumbnail();  //TODO:V2
    this.checkProfile();
  },
  watch: {
    profile(val) {
      if (this.heartbeat && val.userId) {
        this.isLoading = false;
        this.heartBeatVerificationCheckAndDataPull();
      }
      return val;
    },
    heartbeat(val) {
      if(val && val.imgURL) {
        const overlayPayload = {
          show: true,
          variant: 'warning',
          imgURL: val.imgURL,
          completedSteps: 1,
          totalSteps: 10
        }
        this.$root.$emit("showHelp");
        this.$root.$emit("showHelpPane");
        this.$emit("show-overlay", overlayPayload);
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      heartbeats: "user/heartbeats",
      heartbeatInfos: "heartbeats/heartbeatInfos"
    }),
    heartbeat() {
      if (
          this.profile &&
          this.profile.heartbeat &&
          this.profile.heartbeat.profileName === this.heartbeatSlug
      ) {
        return {
          uid: this.profile.userId,
          imgURL: this.profile.imgURL,
          name: `${this.profile.firstname} ${this.profile.lastname}`,
          isSelf: true
        };
      }
      return this.heartbeats && Array.isArray(this.heartbeats)
          ? this.heartbeats.filter(hb => {
            return hb.slug === this.heartbeatSlug;
          })[0]
          : null;
    },
    heartBeatUID() {
      return this.heartbeat && this.heartbeat.uid ? this.heartbeat.uid : null;
    },
    theHeartBeatInfo(){
      return this.heartbeatInfos && this.heartBeatUID && this.heartbeatInfos[this.heartBeatUID]?
          this.heartbeatInfos[this.heartBeatUID] : null;
    },
    family() {
      return this.theHeartBeatInfo &&
      this.theHeartBeatInfo.family
          ? this.theHeartBeatInfo.family
          : null;
    },
    familyActive() {
      return this.family && Array.isArray(this.family) && this.family.filter( aMember =>{
        return aMember.status && aMember.status.status && aMember.status.status === 'active';
      });
    },
    apps() {
      return this.theHeartBeatInfo &&
      this.theHeartBeatInfo.family
          ? this.theHeartBeatInfo.apps
          : [];
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        heartbeat: this.heartbeat,
        family: this.familyActive,
        apps: this.apps
      };
    },
    profileVideo() {
      return this.profile &&
      this.profile.guide &&
      this.profile.guide._dashboards &&
      this.profile._dashboards.guide
          ? this.profile._dashboards.guide.video
          : "";
    },
    published_at() {
      return this.profile &&
      this.profile.guide &&
      this.profile.guide._dashboards &&
      this.profile._dashboards.guide
          ? this.profile._dashboards.guide._published_at
          : "";
    },
    profileName() {
      return this.profile &&
      this.profile.guide &&
      this.profile.guide._dashboards &&
      this.profile._dashboards.guide
          ? this.profile._dashboards.guide.profileName
          : "";
    },
    expertise() {
      return this.profile &&
      this.profile.guide &&
      this.profile.guide._dashboards &&
      this.profile._dashboards.guide
          ? this.profile._dashboards.guide.expertise
          : [];
    },
    displayProfile() {
      return this.profile &&
      this.profile.guide &&
      this.profile.guide._dashboards &&
      this.profile._dashboards.guide
          ? this.profile._dashboards.guide.displayProfile
          : null;
    },
    videoId() {
      return this.profile &&
      this.profile._dashboards &&
      this.profile._dashboards.guide &&
      this.profile._dashboards.guide.video
          ? this.profile._dashboards.guide.video.videoId
          : null;
    },
    videoThumb() {
      return this.profile &&
      this.profile._dashboards &&
      this.profile._dashboards.guide &&
      this.profile._dashboards.guide.video
          ? this.profile._dashboards.guide.video.videoThumb
          : null;
    },
    accountType() {
      let type = "Free";
      if (this.profile &&
          this.profile._dashboards &&
          this.profile._dashboards.guide._account &&
          this.profile._dashboards.guide._account.type == "starter"
      )
        type = "Starter";
      else if (
          this.profile &&
          this.profile._dashboards &&
          this.profile._dashboards.guide._account &&
          this.profile._dashboards.guide._account.type == "premium"
      )
        type = "Premium";
      return type;
    }
  },
  methods: {
    handleNoHeartbeatData() {
      this.$router.push("/app");
    },
    heartBeatVerificationCheckAndDataPull() {
      this.$store
        .dispatch("heartbeats/verifyHeartBeatAccess", {
          heartbeat: this.heartbeat,
          profile: this.profile
        })
        .then(res => {
          this.approval = res;
          if (res._isApproved) {
            this.$store
              .dispatch("heartbeats/getAppsForHeartBeat", {
                heartbeat: this.heartbeat
              })
              .then(res => {
                this.allLoaded = true;
                this.$forceUpdate();
                console.log(res);
              })
              .catch(e => {
                console.error(e);
              });
          } else {
            this.handleNoHeartbeatData();
          }
        })
        .catch(e => {
          this.handleNoHeartbeatData();
          console.log(e);
        });
    },
    getHeartbeatsIfNecessary() {
      return new Promise(async (resolve, reject) => {
        if (!this.heartbeats) {
          this.$store
            .dispatch("user/getListHeartbeats")
            .then(res => {
              resolve(res);
            })
            .catch(e => {
              reject(e);
            });
        } else {
          resolve(this.heartbeats);
        }
      });
    },
    //else use cached for now
    //@ToDo how can it be handled better
    checkProfile() {
      if (this.profile) return;
      this.$store.dispatch("user/getProfile");
    },
    handleWatchProfileVideo() {
      if (this.videoId) {
        console.log(`Blog Video is ${this.videoId}`);
        this.$bvModal.show(this.videoModalId);
      }
    },
    getVideoThumbnail() {
      if (this.profileVideo && !this.profileVideo.videoThumb) {
        this.getVideoThumbnail(this.profileVideo.videoId).then(thumbnail => {
          this.$store
              .dispatch("user/updateGuideVideoThumbnail", thumbnail)
              .then(res => {
                this.$store.dispatch("user/getProfile");
              });
        });
      }
    },
    getInitials(fname, lname) {
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    copytoClipboard(link) {
      navigator.clipboard.writeText(link);
      this.popupText = "Copied!";
    },
    changePopupText() {
      setTimeout(() => {
        this.popupText = "Copy to clipboard";
      }, 300);
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) return truthy;
      else return def;
    },
    handleProcessComplete() {
    },
    updateGuideInfo() {
      this.$store
          .dispatch("listings/updateGuideInfo", this.profile)
          .then(res => {
            this.$store
                .dispatch("user/publishedGuideInfo", this.profile)
                .then(res => {
                  this.$store.dispatch("user/getProfile").then(() => {
                    this.$store.dispatch("user/showNotification", {
                      title: "Successfully Publised",
                      description: "Users can see your changes now.",
                      variant: "success"
                    });
                  });
                });
          });
    },
    playGuideVideo() {
      if (
          this.profile._dashboards.guide.video &&
          this.profile._dashboards.guide.video.videoId &&
          this.profile._dashboards.guide.video.videoThumb
      ) {
        console.log(this.profile._dashboards.guide.video.videoId);
        this.$bvModal.show(this.guideVideo);
      }
    },
    triggerChooseVideo() {
      document.getElementById("crew-profile-video").click();
    },
    uploadCrewProfileVideo(event) {
      let file = event.target.files[0];
      let name = `crew_profile_${this.profile.userId}_${(Date.now() / 1000) |
      0}`;
      let description = `${this.profile.firstname}'s Crew Profile Video.`;
      this.uploadVideo(file, name, description).then(video => {
        this.saveVideo(video);
      });
    },
    saveVideo({ videoName, vimeoURL, videoId, vimeoName }) {
      this.processingVideo = true;
      let dataToUpdate = {
        guide: {
          video: {
            _created_at: new Date(),
            videoName,
            vimeoURL,
            videoId,
            vimeoName
          }
        }
      };
      this.$store
          .dispatch("user/updateProfileDashboardGuide", dataToUpdate)
          .then(res => {
            this.getVideoThumbnail(videoId).then(thumbnail => {
              this.$store
                  .dispatch("user/updateGuideVideoThumbnail", thumbnail)
                  .then(res => {
                    this.$store.dispatch("user/getProfile").then(() => {
                      this.processingVideo = false;
                      this.$store.dispatch("user/showNotification", {
                        title: "Video has been uploaded successfully.",
                        description:
                            "Users will not see this info until you Publish.",
                        variant: "success"
                      });
                    });
                  });
            });
          })
          .catch(e => {
            this.$store.dispatch("user/getProfile");
            this.processingVideo = false;
            console.log(e);
          });
    }
  },
  data() {
    return {
      variant: 'warning',
      opacity: 0.45,
      blur: '2px',
      showOverlay: true,
      completedSteps: 5,
      totalSteps: 10,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 100,
        height: 100,
        class: "m1"
      },
      bodyMode:'apps',  //apps | calendar
      allLoaded: false,
      approval: {
        _isApproved: false,
        status: "none",
        family: []
      },
      heartbeatSlug: null,
      v2: true,
      isLoading: true,
      fetching: false,
      processingVideo: false,
      guideVideo: "guide-video",
      popupText: "Copy to clipboard",
      sections: [
        {
          title: "Communicate",
          id: "communicate",
          component: Communicate,
          componentName: "Communicate",
          avail: false
        },
        {
          title: "Communicate",
          id: "bodyCommunicate",
          component: BodyCommunicate,
          componentName: "BodyCommunicate",
          avail: true
        },
        {
          title: "Profile Info",
          id: "profileInfo",
          component: ProfileInfo,
          componentName: "ProfileInfo",
          avail: false
        },
        {
          title: "Social Networks",
          id: "social",
          component: Socials,
          componentName: "Social",
          avail: false
        },
        {
          title: "Tags",
          id: "tags",
          component: Tags,
          componentName: "Tags",
          avail: false
        },
        {
          title: "FAQs",
          id: "faqs",
          component: Faqs,
          componentName: "Faqs",
          avail: false
        },
        {
          title: "Plans", //@TODO- make events for Authors
          id: "plans",
          component: Plans,
          componentName: "Plans",
          avail: false
        },
        {
          title: "Sessions",
          id: "sessions",
          component: Sessions,
          componentName: "Sessions",
          avail: false
        },
        {
          title: "MyApps",
          id: "publishings",
          component: Publishings,
          componentName: "Publishings",
          avail: false
        },
        {
          title: "Tracks",
          id: "tracks",
          component: Tracks,
          componentName: "Tracks",
          avail: false
        }
      ],
      videoModalId: "crewProfileVideo"
    };
  }
};
</script>

<style lang="scss" scoped>
.guide-management {
  padding: 24px;
  height: 100%;
  .profile-card {
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    padding: 16px;
    .personel {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .avatar {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        object-fit: cover;
      }
      .profile-name {
        margin-left: 10px;
        h3 {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin-bottom: 0;
        }
      }
    }
    .desc {
      margin-top: 15px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;

        /* Body */

        color: #474d52;
      }
    }
    .foot {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > div {
        margin-right: 12px;
        cursor: pointer;
      }
    }
  }
  .published {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #474d52;
    display: block;
    margin-top: 15px;
    @media (max-width: 991px) {
      margin-top: 34px !important;
      margin-bottom: 40px;
    }
  }
  .btn-round-fill {
    margin: 18px 0px;
  }
}
.heading__ {
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #8d99a0;
  text-transform: uppercase;
  margin-bottom: 0;
  margin-top: 10px;
}
.link__ {
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
  .link {
    overflow-wrap: anywhere;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #557efb;
  }
  .ico {
    cursor: pointer;
    justify-self: flex-end;
  }
}
.skeleton-name {
  width: 80px;
  margin-top: 11px;
  margin-left: 11px;
}
.skeleton-btn {
  border-radius: 20px;
}
.skeleton-input {
  border-radius: 16px;
}
.dash-border {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23ddddddff' stroke-width='1' stroke-dasharray='3%2c 6' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  height: 1px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.skeleton-toggle {
  height: 30px;
  width: 70px;
  margin-top: 13px;
}
.foot {
  margin-top: 15px;
  border-top: 1px solid #dddddd;
  padding-top: 10px;
}
.skeleton-save-btn {
  border-radius: 20px;
  width: 120px;
}
.upload {
  margin-bottom: 1rem;
  .upload-video {
    margin-top: 15px;
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #8d99a0;
  }
  .upload-btn {
    margin-top: 16px;
    width: 208px;
    height: 40px;
    border-radius: 100px;
    border: none;
    outline: none !important;
    .ico {
      margin-right: 5px;
    }
    .btn-content {
      margin-top: 5px;
      font-family: Nunito;
      font-style: normal;
      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
      color: #557efb;
    }
  }
  .video {
    color: #fff !important;
    background-color: #557efb !important;
  }
  .no-video {
    color: #557efb;
    background: rgba(85, 126, 251, 0.1);
  }
  .watch-video {
    margin-top: 5px;
    font-family: Nunito;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>